import styled from "@emotion/styled"
import { theme } from "@pallet-hq/hegel"
import { FullPageColumn } from "page-components/atoms/AppPages"
import NoPermissions from "./NoPermissions"

const PageNotFound = () => (
    <FullPageColumn>
        {/* TODO: Add a standardized navbar */}
        <Navbar />
        <NoPermissions />
    </FullPageColumn>
)

export default PageNotFound

const Navbar = styled.div`
    width: 100%;
    height: 64px;
    background-color: ${theme.colors.gray100};
`
